import Vue from "vue";

export class Logger {
    messages: string[] = Vue.observable([]);

    log(msg: string) {
        this.messages.push(msg);
    }

    clear() {
        this.messages = Vue.observable([]);
    }
}

export const loggerInstance = new Logger();
